// Amplitude initialization state
// This module avoids circular dependencies by being imported by both index.ts and viewed-tracking.ts
let isInitialized = false;
export function setAmplitudeInitialized(initialized) {
    isInitialized = initialized;
}
export function getAmplitudeInitialized() {
    return isInitialized;
}
